import React, { useState } from "react";

/**
 * Password input with a show/hide eye toggle.
 * Props mirror the common subset of <input>: value, onChange, placeholder,
 * autoComplete, disabled, className, id.
 */
const PasswordInput = ({
  value,
  onChange,
  placeholder,
  autoComplete,
  disabled,
  className = "form-control",
  id,
}) => {
  const [show, setShow] = useState(false);
  return (
    <div style={{ position: "relative" }}>
      <input
        id={id}
        type={show ? "text" : "password"}
        className={className}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        disabled={disabled}
        style={{ paddingRight: 40 }}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        disabled={disabled}
        aria-label={show ? "Hide password" : "Show password"}
        title={show ? "Hide password" : "Show password"}
        style={{
          position: "absolute",
          right: 8,
          top: "50%",
          transform: "translateY(-50%)",
          background: "transparent",
          border: "none",
          cursor: disabled ? "not-allowed" : "pointer",
          color: "#6b7280",
          padding: "4px 6px",
          lineHeight: 1,
        }}
      >
        <i
          className={show ? "fa fa-eye-slash" : "fa fa-eye"}
          aria-hidden="true"
        ></i>
      </button>
    </div>
  );
};

export default PasswordInput;
